import axios from "axios";
import { authFetch } from "../helpers/FetchHelpers";
import * as moment from "moment";
const { default: DataService } = require("./DataService");

class CreditDataService extends DataService {
    constructor() {
        super("kredit")
    }

    validate(item) {
        return authFetch(process.env.REACT_APP_API_URL + '/' + this.entity + '/check', 'POST', JSON.stringify(item))
            .then((data) => {
                return {
                    data: data.data != null && data.data.errorMessage === undefined ? data.data : undefined,
                    errorMessage: data.data?.errorMessage,
                    needRelogin: data.data?.needRelogin,
                }
            });
    }

    getMaxCredit() {
        return authFetch(process.env.REACT_APP_API_URL + '/max_kredit', 'GET', null);
    }

    updateMaxCredit(item) {
        return authFetch(process.env.REACT_APP_API_URL + '/max_kredit', 'PUT', JSON.stringify(item));
    }

    getCreditByNIK(nik) {
        return authFetch(process.env.REACT_APP_API_URL + '/kredit/user?nik=' + nik, 'GET', null)
            .then((data) => {
                return {
                    data: data.data != null && data.data.errorMessage === undefined ? data.data : undefined,
                    errorMessage: data.data?.errorMessage,
                    needRelogin: data.data?.needRelogin,
                }
            });
    }

    payOffCredit(reportId, kreditId) {
        return authFetch(process.env.REACT_APP_API_URL + '/' + this.entity + '/lunasin', 'POST', JSON.stringify({
            report_id: reportId,
            kredit_id: kreditId,
        })).then((data) => {
            return {
                data: data.data != null && data.data.header?.errorMessage === undefined ? data.data : undefined,
                errorMessage: data.data?.header?.errorMessage,
                needRelogin: data.data?.needRelogin,
            }
        });
    }

    dropCredit(kreditId) {
        return authFetch(process.env.REACT_APP_API_URL + '/' + this.entity + '/drop', 'POST', JSON.stringify({
            kredit_id: kreditId,
        })).then((data) => {
            return {
                data: data.data != null && data.data.header?.errorMessage === undefined ? data.data : undefined,
                errorMessage: data.data?.header?.errorMessage,
                needRelogin: data.data?.needRelogin,
            }
        });
    }

    getDailyReport() {
        let from = new Date();
        let to = new Date();
        from.setHours(0, 0, 0, 0);
        to.setHours(23, 59, 59, 59);
        let query = 'from=' + moment(from.toISOString(), 'YYYY-MM-DDTHH:mm:ss.sssZ').format('YYYY-MM-DD HH:mm:ss') 
            + '&to=' + moment(to.toISOString(), 'YYYY-MM-DDTHH:mm:ss.sssZ').format('YYYY-MM-DD HH:mm:ss');

        return authFetch(process.env.REACT_APP_API_URL + '/report/daily?' + query, 'GET', null);         
    }

    exportDailyReport(startDate, endDate) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            timeout: 60000,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwt_auth_token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        let url = '/kredit/report/daily';
        let body = {
            from: startDate,
            to: endDate,
        };

        return instance.post(url, body, {
            responseType: 'arraybuffer',
        }).then(response => {
            // response.data is an empty object
            const blob = new Blob([response.data], {
                type: 'application/xlsx',
            });
            var FileSaver = require('file-saver');
            FileSaver.saveAs(blob, startDate + " - " + endDate + '.xlsx');
        })
    }

    exportReport(startDate, endDate, isUnion, reportId) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            timeout: 60000,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwt_auth_token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        let url = isUnion ? '/kredit/report/union' : '/kredit/report';
        let body = isUnion ? {
            report_id: reportId,
        } : {
            from: startDate,
            to: endDate,
        };

        return instance.post(url, body, {
            responseType: 'arraybuffer',
        }).then(response => {
            // response.data is an empty object
            const blob = new Blob([response.data], {
                type: 'application/xlsx',
            });
            var FileSaver = require('file-saver');
            FileSaver.saveAs(blob, new Date(startDate).toLocaleDateString() + "-" + new Date(endDate).toLocaleDateString() + '.xlsx');
        }).catch(err => {
            if (err.response.request.responseType === 'arraybuffer'
                && err.response.data.toString() === '[object ArrayBuffer]'
            ) {
                /** error response */
                const res = JSON.parse(Buffer.from(err.response.data).toString('utf8'));
                return { errorMessage: res.header.error_message };
            }
        });
    }

    exportReportById(reportId) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            timeout: 60000,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwt_auth_token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        return instance.get('/kredit/report/file?report_id=' + reportId, {
            responseType: 'arraybuffer',
        }).then(response => {
            // response.data is an empty object
            const blob = new Blob([response.data], {
                type: 'application/xlsx',
            });
            var FileSaver = require('file-saver');
            FileSaver.saveAs(blob, 'Report-' + reportId + '.xlsx');
        }).catch(err => {
            if (err.response.request.responseType === 'arraybuffer'
                && err.response.data.toString() === '[object ArrayBuffer]'
            ) {
                /** error response */
                const res = JSON.parse(Buffer.from(err.response.data).toString('utf8'));
                return { errorMessage: res.header.error_message };
            }
        });   
    }

    getReports(currentPage, perPage, status = null) {
        const baseUrl = process.env.REACT_APP_API_URL + '/kredit/report';
        const params = new URLSearchParams({
            page: currentPage,
            per_page: perPage,
            ...(status !== null && { status })
        });

        const url = `${baseUrl}?${params.toString()}`;
        return authFetch(url, 'GET', null)
            .then((data) => {
                return {
                    reports: data.data.report_list !== null && data.data.errorMessage === undefined ? data.data.report_list : [],
                    totalPages: data.data.total_data < perPage ? 1 : Math.ceil(data.data.total_data / perPage),
                    errorMessage: data.data?.errorMessage,
                    needRelogin: data.data?.needRelogin,
                }
            });
    }

    proceedReport(reportId) {
        return authFetch(process.env.REACT_APP_API_URL + '/' + this.entity + '/report/proceed', 'POST', JSON.stringify({
            report_id: reportId,
        })).then((data) => {
            return {
                data: data.data != null && data.data.header?.errorMessage === undefined ? data.data : undefined,
                errorMessage: data.data?.header?.errorMessage,
                needRelogin: data.data?.needRelogin,
            }
        });
    }
}

export default CreditDataService;